


















































import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ConfirmPopup from '@/components/molecules/ConfirmPopup/ConfirmPopup.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

import { ConfirmDialogOptions } from '@/models/confirm-dialog';

export const CONFIRM_DIALOG_DEFAUL_OPTIONS = {
  title:
    'Data entered in the form will be discarded when closing without saving.',
  description: '',
  cancelButtonText: 'Cancel',
  confirmButtonText: 'Discard and close',
  align: 'center'
};

@Component<ConfirmDialog>({
  components: {
    Typography,
    ConfirmPopup,
    FilledButton,
    CloseModalIcon
  }
})
export default class ConfirmDialog extends Vue {
  options: ConfirmDialogOptions = CONFIRM_DIALOG_DEFAUL_OPTIONS;

  resolvePromise: any;
  rejectPromise: any;

  handleClose() {
    const popup = this.$refs.popup as any;

    if (popup) {
      window.parent.postMessage(
        { type: 'eventbus:emit', data: { event: 'closeModal' } },
        '*'
      );
      setTimeout(() => {
        popup.toggle();
      }, 0);
    }
  }

  handleShow() {
    const popup = this.$refs.popup as any;

    if (popup) {
      popup.toggle();
    }
  }

  show(options = {}) {
    this.options = {
      ...CONFIRM_DIALOG_DEFAUL_OPTIONS,
      ...options
    };

    this.handleShow();

    return new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;
    });
  }

  onConfirm() {
    this.handleClose();
    this.resolvePromise('confirm');
  }

  onCancel() {
    this.handleClose();
    this.resolvePromise('cancel');
  }
}
